import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'cre-ng';

import { Configuration, Month } from '@app/core/model/configuration.model';
import { IConfigurationService } from '@app/core/services/interface/IConfigurationService';

@Injectable()
export class ConfigurationService extends BaseService implements IConfigurationService {
  constructor(protected httpClient: HttpClient) {
    super({ serviceApiDomain: window.__env.ngSettings.serviceApiDomain }, httpClient);
  }

  getConfiguration(): Promise<Configuration> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient
      .get<Configuration>(this.serviceUrl + '/configuration', requestOptions)
      .toPromise();
  }

  getDisplaypayablemonths(): Promise<Month[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient
      .get<Month[]>(this.serviceUrl + '/configuration/displaypayablemonths', requestOptions)
      .toPromise();
  }

  getEndPoint(): string {
    return '/safeandontime/api/v1';
  }
}
